import { PlusCircle } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import AddSourceFlow from "../AddSourceFlow";

export default function AddLeadsButton({ listId }: { listId: string }) {
  const isDesktop = useTwBreakpoint("lg");

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Trigger = isDesktop ? DialogTrigger : DrawerTrigger;

  return (
    <Component open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <Trigger asChild>
        <Button
          size={isDesktop ? "sm" : "md"}
          leftIcon={<PlusCircle weight="fill" />}
        >
          Add leads
        </Button>
      </Trigger>
      <Content size={listId ? "lg" : "md"}>
        <AddSourceFlow
          listId={listId}
          //TODO: select the origin on add success
          onAddSuccess={() => setIsDialogOpen(false)}
        />
      </Content>
    </Component>
  );
}
